import React from 'react';
import FileTypeFront from './EditShareModal.icons/FileTypeFront';
import FileTypeFold from './EditShareModal.icons/FileTypeFold';
import PdfGlyph from './EditShareModal.icons/PdfGlyph';
import JpgGlyph from './EditShareModal.icons/JpgGlyph';
import WordGlyph from './EditShareModal.icons/WordGlyph';
import ExcelGlyph from './EditShareModal.icons/ExcelGlyph';
import PptxGlyph from './EditShareModal.icons/PptxGlyph';
import { EditShareOptionId } from './EditShareModal.types';

export const OPTIONS: Array<{
  id: EditShareOptionId;
  label: string;
  color: string;
  glyphTop: string;
  Glyph?: typeof PdfGlyph;
  badge?: string;
}> = [
  {
    id: 'pdf',
    label: 'PDF',
    color: '#D92D20',
    glyphTop: '8.4px',
    Glyph: PdfGlyph,
  },
  {
    id: 'jpg',
    label: 'JPG',
    color: '#6938EF',
    glyphTop: '8.4px',
    Glyph: JpgGlyph,
  },
  {
    id: 'word',
    label: 'Word',
    color: '#155EEF',
    glyphTop: '8.4px',
    Glyph: WordGlyph,
  },
  {
    id: 'excel',
    label: 'Excel',
    color: '#079455',
    glyphTop: '8px',
    Glyph: ExcelGlyph,
  },
  {
    id: 'pptx',
    label: 'PPTX',
    color: '#E04F16',
    glyphTop: '9px',
    Glyph: PptxGlyph,
  },
  {
    id: 'compressed',
    label: 'Compressed',
    color: '#444CE7',
    glyphTop: '10px',
    badge: 'ZIP',
  },
];

export const DOWNLOAD_BUTTON_LABEL: Record<EditShareOptionId, string> = {
  pdf: 'Download PDF',
  jpg: 'Download JPG',
  word: 'Download Word',
  excel: 'Download Excel',
  pptx: 'Download PPTX',
  compressed: 'Download',
};

export const FileTypeIcon = ({
  color,
  glyphTop,
  Glyph,
  badge,
}: {
  color: string;
  glyphTop: string;
  Glyph?: typeof PdfGlyph;
  badge?: string;
}) => (
  <div className="relative h-6 w-6 shrink-0 overflow-hidden">
    <div
      className="absolute inset-y-0 left-[2.4px] right-[2.4px]"
      style={{ color }}
    >
      <FileTypeFront className="h-full w-full" />
    </div>
    <div className="absolute right-[2.4px] top-0 h-[7.2px] w-[7.2px]">
      <FileTypeFold className="h-full w-full" />
    </div>
    {badge ? (
      <div
        className="absolute left-1/2 flex h-[9px] w-[15.333px] -translate-x-1/2 items-center justify-center rounded-[2px] bg-[#7c82ee]"
        style={{ top: glyphTop }}
      >
        <span className="font-inter text-[6px] font-bold leading-none text-white">
          {badge}
        </span>
      </div>
    ) : Glyph ? (
      <Glyph
        className="absolute left-1/2 h-3 w-3 -translate-x-1/2"
        style={{ top: glyphTop }}
      />
    ) : null}
  </div>
);
